import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgWindows = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "none", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.005 12 3 6.408l6.8-.923v6.517H3.005ZM11 5.32 19.997 4v8H11zM20.067 13l-.069 8-9.065-1.275L11 13zM9.8 19.58l-6.795-.931V13H9.8z",
    clipRule: "evenodd"
  }
) }));

export { SvgWindows as default };
//# sourceMappingURL=windows.mjs.map
